// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The document registry token.
 */
export const IDocumentManager = new Token('@jupyterlab/docmanager:IDocumentManager', `A service for the manager for all
  documents used by the application. Use this if you want to open and close documents,
  create and delete files, and otherwise interact with the file system.`);
/**
 * The document widget opener token.
 */
export const IDocumentWidgetOpener = new Token('@jupyterlab/docmanager:IDocumentWidgetOpener', `A service to open a widget.`);
/**
 * The recent documents database token.
 */
export const IRecentsManager = new Token('@jupyterlab/docmanager:IRecentsManager', `A service providing information about recently opened and closed documents`);
/**
 * The document manager dialogs token.
 */
export const IDocumentManagerDialogs = new Token('@jupyterlab/docmanager:IDocumentManagerDialogs', 'A service for displaying dialogs related to document management.');
//# sourceMappingURL=tokens.js.map